const checkFormulaValidation = (state, outputFormulaEditorType) => {
  const disabledFn = false;
  if (state.outputformula) {
    if (
      Object.keys(state.outputformula).includes('caseList') &&
      outputFormulaEditorType !== 'single'
    ) {
      const hasCaseErrors = state.outputformula.caseList.some(
        (element) => element?.whenError !== '' || element?.thenError !== ''
      );
      return hasCaseErrors || state.outputformula?.elseError !== '';
    }
    if (!state.outputformula?.query || state.outputformula?.error !== '') {
      return !state.outputformula?.query || state.outputformula?.error !== '';
    }
  }
  if (state.ruleApplicabilty) {
    if (
      Object.keys(state.ruleApplicabilty).includes('caseList') &&
      state.ruleApplicabilityModeType !== 'single'
    ) {
      const hasCaseErrors = state.ruleApplicabilty?.caseList.some(
        (element) => element?.whenError !== '' || element?.thenError !== ''
      );
      return hasCaseErrors || state.ruleApplicabilty?.elseError !== '';
    }
    if (
      !state.ruleApplicabilty?.query ||
      state.ruleApplicabilty?.error !== ''
    ) {
      return (
        !state.ruleApplicabilty?.query || state.ruleApplicabilty?.error !== ''
      );
    }
  }
  return disabledFn;
};

export default checkFormulaValidation;
